import { IPoint2d } from '@/editor/math/IPoint2d';
import { Hole } from '../hole';
import { pixelRatio3d } from '@/editor/math/const';
import { Shape, ShapeGeometry } from 'three';
import { dispersePath } from '@/editor/utils/shape';

export function calPlaneOutline(width: number, height: number, offGround: number) {
  const outline: IPoint2d[] = [];
  outline.push(
    {
      x: -width / 2,
      y: -height / 2 + offGround
    },
    {
      x: width / 2,
      y: -height / 2 + offGround
    },
    {
      x: width / 2,
      y: height / 2 + offGround
    },
    {
      x: -width / 2,
      y: height / 2 + offGround
    }
  );

  return outline;
}

// y轴与在地面
export function calPlaneOutline2(width: number, height: number, offGround: number) {
  const outline: IPoint2d[] = [];
  outline.push(
    {
      x: -width / 2,
      y: offGround
    },
    {
      x: width / 2,
      y: offGround
    },
    {
      x: width / 2,
      y: height + offGround
    },
    {
      x: -width / 2,
      y: height + offGround
    }
  );

  return outline;
}

export function equalHoles(holes1: Hole[], holes2: Hole[]) {
  if (holes1.length !== holes2.length) return false;

  holes1.sort((a, b) => a.getCenter().x - b.getCenter().x);
  holes2.sort((a, b) => a.getCenter().x - b.getCenter().x);

  for (let i = 0; i < holes1.length; i++) {
    if (!holes1[i].isEqual(holes2[i])) return false;
  }
  return true;
}

// TODO: 需要优化，扩展开洞数据，替换countourModel中的计算
export function createPlaneGeometry(contour: (IPoint2d & { center?: IPoint2d; clockwise?: boolean })[]) {
  const impreciseOutlone = dispersePath(contour).map((pt) => ({
    x: Number((pt.x / pixelRatio3d).toFixed(6)),
    y: Number((pt.y / pixelRatio3d).toFixed(6))
  }));

  const shape = new Shape();
  impreciseOutlone.forEach((point, index) => {
    if (index === 0) {
      shape.moveTo(point.x, point.y);
    } else {
      shape.lineTo(point.x, point.y);
    }
  });
  shape.closePath();

  return new ShapeGeometry(shape);
}
